export default __webpack_public_path__ + "static/media/icon-minus.c40f2405.svg";